const menusES = {}

export default menusES
